import { LogoWithHeaderCombinedProps } from './types';

const usePresenter = (props: LogoWithHeaderCombinedProps): LogoWithHeaderCombinedProps => {
  return props;
};

export default usePresenter;
